import Blue from "~/dfwjobs/core";

new Blue({
	name: 'FooterBackToTop',
	selector: ".footer",
	setup(footer) {
		const button = footer.querySelector('.footer__to-top');
		const toggleVisibility = () => {
			if (window.pageYOffset > 400) {
				return button.classList.add('is-active');
			}
			button.classList.remove('is-active');
		}
		const goToTop = () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
		const buttonBottom = parseInt(getComputedStyle(button).bottom);
		const compensateForFooter = () => {
			const wHeight = window.innerHeight;
			const footerRect = footer.getBoundingClientRect();
			const buttonHeight = button.offsetHeight / 2;
			if (footerRect.top <= wHeight - buttonBottom - buttonHeight) {
				button.style.bottom = `${Math.abs((footerRect.top - wHeight) + buttonHeight)}px`;
			}
			else {
				button.style.bottom = '';
			}
		}

		this.$addEvents(button, 'click.stop.prevent enter.stop.prevent', goToTop);
		this.$addEvents(window, 'scroll', toggleVisibility);
		this.$addEvents(window, 'scroll', compensateForFooter);
		toggleVisibility();
		compensateForFooter();
	}
});